<svg width="24" height="15" viewBox="0 0 24 15"  xmlns="http://www.w3.org/2000/svg">
  <path d="M10.7294 1.56305C11.5199 0.717383 12.8611 0.71738 13.6515 1.56305L23.0657 11.6342C24.2604 12.9123 23.3541 15 21.6046 15H2.77634C1.02686 15 0.120592 12.9123 1.31527 11.6343L10.7294 1.56305Z" fill="#F2F2F2"/>
</svg>
